import { render, staticRenderFns } from "./Navbutton.vue?vue&type=template&id=b712eae8&scoped=true"
import script from "./Navbutton.vue?vue&type=script&lang=js"
export * from "./Navbutton.vue?vue&type=script&lang=js"
import style0 from "./Navbutton.vue?vue&type=style&index=0&id=b712eae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b712eae8",
  null
  
)

export default component.exports